import { api } from './api'

export interface VoiceStatus {
  available: boolean
  languages: string[]
  max_seconds: number
}

export interface TranscriptionResponse {
  text: string
  language: string
}

/** Server-side dictation: upload a 16 kHz mono WAV, get the words back. */
export const voiceApi = {
  status: (slug: string) =>
    api.get<VoiceStatus>(`/api/v2/orgs/${encodeURIComponent(slug)}/voice/status`),

  transcribe: (slug: string, wav: ArrayBuffer, language: string, signal?: AbortSignal) => {
    const body = new FormData()
    body.append('audio', new Blob([wav], { type: 'audio/wav' }), 'voice.wav')
    body.append('language', language)
    return api.post<TranscriptionResponse>(
      `/api/v2/orgs/${encodeURIComponent(slug)}/voice/transcriptions`,
      body,
      { signal },
    )
  },
}
